const get = require('lodash/get');
// TODO: This is a performance, lazy-load target. Need to get dynamic imports() working first
// const SplitFactory = require('@splitsoftware/splitio').SplitFactory;
const SplitFactory = false;

function getSplitObject(rp_app) {
	const authorizationKey = get(rp_app, 'env.splitio.env.api_key', false);
	const key = get(rp_app, 'env.splitio.data.user_id', false);
	const trafficType = get(rp_app, 'env.splitio.data.traffic_type', false);

	// Setup the stub. Without it the app would throw JS errors for track calls or const usage
	let split = {
		consts: {
			VP_CLICK: 'webstore_vp_click',
			PRODUCT_VP_CLICK: 'webstore_product_vp_click',
		},
		env: {},
		client: {},
		manager: {},
		onReady: () => {},
		track: () => {},
	};

	if (authorizationKey && key && SplitFactory) {
		// Config here - https://docs.split.io/docs/javascript-sdk-overview#section-configuration
		const factory = SplitFactory({
			startup: {
				eventsFirstPushWindow: 5,
			},
			core: {
				authorizationKey,
				key: key,
				trafficType,
			},
			storage: {
				type: 'LOCALSTORAGE', // 'MEMORY' if you don't like the cache
			},
			scheduler: {
				eventsPushRate: 10,
			},
			// debug: true, // Or set `localStorage.splitio_debug = 'on'` in browser console
		});

		split = {
			...split,
			env: {
				trafficType,
			},
			client: factory.client(),
			manager: factory.manager(),
			onReady: (fn) => {
				rp_app.split.client.on(rp_app.split.client.Event.SDK_READY, fn);
			},
			track: (event) => {
				rp_app.split.client.track(event);
			},
		};
	}

	return split;
}

module.exports = (rp_app) => {
	return getSplitObject(rp_app);
};
